import { FormHelperText } from "@mui/material";
import { M_InputTextField } from "../../../../M_Components";
import { t } from "i18next";

const NumericForm = ({ propertyChangeCallback, isDecimalField, field, errors, canEdit }) => {
    const isRangeValid = errors["range"] === undefined ||
        errors["range"] === null;

    const handleChange = (property, value) => {
        if (value === "") {
            propertyChangeCallback(property, null);
            return;
        }

        if (property === "decimalDigits" && value.includes(".")) {
            return;
        }
        if ((property === "maxValue" || property === "minValue") &&
            !isDecimalField &&
            value.includes(".")) {
            return;
        }

        propertyChangeCallback(property, value);
    }

    const handleNumberValueChange = (property, value) => {
        const regex = /^-?\d*\.?\d*$/;
        if (regex.test(value)) {
            if (value === "") {
                propertyChangeCallback(property, null);
                return;
            }
            propertyChangeCallback(property, value);
        }
    }

    return (
        <>
            <div className="field-one-columns" >
                <M_InputTextField
                    label={t("NgeDefaultValue")}
                    value={field.defaultValue ?? ""}
                    onChange={(e) => handleNumberValueChange("defaultValue", e.target.value)}
                    disabled={!canEdit}
                    type="number"
                />
            </div>
            <div className="field-one-columns">
                <M_InputTextField
                    disabled={!canEdit}
                    label={t("NgeUnit")}
                    value={field.unit ?? ""}
                    onChange={(e) => handleChange("unit", e.target.value)}
                />
            </div>
            <div className="field-one-columns">
                <M_InputTextField
                    disabled={!canEdit}
                    label={t("NgeMinVal")}
                    value={field.minValue ?? ""}
                    type="number"
                    color={isRangeValid && canEdit ? null : 'var(--color-red)'}
                    helperTextMessage={errors["range"] !== null && canEdit ? t("NgeInvalidRange") : null}
                    onChange={(e) => handleChange("minValue", e.target.value)}
                />
                <FormHelperText>{errors["range"] !== null && canEdit ? t("NgeInvalidRange") : null}</FormHelperText>
            </div>
            <div className="field-one-columns">
                <M_InputTextField
                    disabled={!canEdit}
                    label={t("NgeMaxVal")}
                    value={field.maxValue ?? ""}
                    type="number"
                    color={isRangeValid && canEdit ? null : 'var(--color-red)'}
                    onChange={(e) => handleChange("maxValue", e.target.value)}
                />
            </div>
            {
                isDecimalField &&
                (
                    <div className="field-one-columns">
                        <M_InputTextField
                            disabled={!canEdit}
                            label={t("NgeDecimalDigits")}
                            value={field.decimalDigits ?? ""}
                            color={errors["decimalDigits"] === null && canEdit ? null : 'var(--color-red)'}
                            helperTextMessage={errors["decimalDigits"] !== null && canEdit ? t(errors["decimalDigits"]) : null}
                            type="number"
                            required
                            onChange={(e) => handleChange("decimalDigits", e.target.value)}
                        />
                        <FormHelperText>{errors["decimalDigits"] !== null && canEdit ? t(errors["decimalDigits"]) : null}</FormHelperText>
                    </div>
                )
            }
             
        </>
    )
}

export default NumericForm;
